import React from 'react';

const DefaultFormatWebProxyLink = props => {
  const {
    accessToken,
    schema,
    path,
    ownData = '',
  } = props;

  return (
    <div className={`default-type-string depth-${path.length}`}>
      <strong className="default-type-string-title">{schema.title}</strong>{' '}
      <div>
      <a
        href={`${ownData}?access_token=${accessToken}`}
        className="format-web-url"
        target="_blank"
        rel="noopener noreferrer"
      >
        Open External Resource
      </a>
      </div>
    </div>
  );
};

export default DefaultFormatWebProxyLink;
